// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiEndpoint: 'https://api-dev.navigatorsurveys.com/api',
  //apiEndpoint: 'https://localhost:44349/api',
  adminSiteUrl: 'https://admin-dev.navigatorsurveys.com',
  idleSeconds: 14400, // 4 hours
  timeoutAfterIdleSeconds: 300,
  jumpApiUrl: 'https://apis.jibunu.blue',
  jumpAppUrl: 'https://apps.jibunu.blue',
  navigatorLink: 'https://nav2-dev.navigatorsurveys.com/',
  aiSummaryEndpoint: 'https://api-dev.navigatorsurveys.com/ai-summary-api',
  usageTracking: {
    enabled: true, // per-environment tracking rollout switch (NK-210)
    flushMaxEvents: 100,
    flushIntervalSeconds: 30,
    postBatchLimit: 500, // 1:1 with Firehose PutRecordBatch
    storageQueueLimit: 2000,
  },
};

// apiEndpoint: 'https://api-staging.navigatorsurveys.com/api',
// apiEndpoint: 'https://api.navigatorsurveys.com/api',
// apiEndpoint: 'https://api-dev.navigatorsurveys.com/api',
// apiEndpoint: 'https://localhost:44349/api',
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
